import {
  GETCUSTOMERLIST_SUCCESS,
  GETCUSTOMERLIST_FAILED,
  RESET_GETCUSTOMERLIST,
  LOADING_GETCUSTOMERLIST,
  NETWORK_ERROR_GETCUSTOMERLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCustomerList = () => {
  return { type: RESET_GETCUSTOMERLIST };
};

const getCustomerList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETCUSTOMERLIST });
  await partnerServices
    .post("getCustomerList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getCustomerListsuccess(res.data));
          break;
        default:
          dispatch(getCustomerListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETCUSTOMERLIST, payload: err });
    });
};
function getCustomerListsuccess(data) {
  return {
    type: GETCUSTOMERLIST_SUCCESS,
    payload: data,
  };
}
function getCustomerListFailed(data) {
  return {
    type: GETCUSTOMERLIST_FAILED,
    payload: data,
  };
}

export { resetGetCustomerList, getCustomerList };
